import {
  CreateFlexibleBlockRequest,
  CreateYardBlockRequest,
  DeleteBayRequest,
  DeleteRowRequest,
  EquipmentTypes,
  InsertBayAfterRequest,
  InsertRowAfterRequest,
  RenameBayRequest,
  RenameRowRequest,
  UpdateFlexibleBlockRequest,
  UpdateYardBlockLayoutPositionRequest,
  UpdateYardBlockRequest,
  YardBlocksApi,
} from '@yard/app/api'
import { createApiClient } from '@yard/app/http-client'

class YardBlockService {
  private readonly httpClient = createApiClient(YardBlocksApi)

  async getYardBlocks(blockIds?: string[]) {
    const { data } = await this.httpClient.getYardBlocks(blockIds)

    return data.yardBlocks
  }

  async getYardBlocksByNames(blockNames: string[]) {
    const { data } = await this.httpClient.getYardBlocksByNames(blockNames)
    return data.yardBlocks
  }

  async updateLayoutPosition(layoutPosition: UpdateYardBlockLayoutPositionRequest) {
    await this.httpClient.updateYardBlockLayoutPosition(layoutPosition)
  }

  async create(yardBlock: CreateYardBlockRequest) {
    const { data } = await this.httpClient.createYardBlock(yardBlock)
    return data.id
  }

  async update(yardBlock: UpdateYardBlockRequest) {
    const { data } = await this.httpClient.updateYardBlock(yardBlock)
    return data
  }

  async createFlexibleBlock(flexibleBlock: CreateFlexibleBlockRequest) {
    const { data } = await this.httpClient.createFlexibleBlock(flexibleBlock)
    return data.id
  }

  async updateFlexibleBlock(flexibleBlock: UpdateFlexibleBlockRequest) {
    const { data } = await this.httpClient.updateFlexibleBlock(flexibleBlock)
    return data
  }

  async updateEquipmentTypes(yardBlockId: string, equipmentTypes: EquipmentTypes[]) {
    await this.httpClient.updateEquipmentTypes({
      id: yardBlockId,
      equipmentTypes,
    })
  }

  async delete(id: string) {
    await this.httpClient.deleteYardBlock({ id })
  }

  async renameBay(request: RenameBayRequest) {
    await this.httpClient.renameBay(request)
  }

  async renameRow(request: RenameRowRequest) {
    await this.httpClient.renameRow(request)
  }

  async insertBayAfter(request: InsertBayAfterRequest) {
    await this.httpClient.insertBayAfter(request)
  }

  async insertBayBefore(request: InsertBayAfterRequest) {
    await this.httpClient.insertBayBefore(request)
  }

  async insertRowAfter(request: InsertRowAfterRequest) {
    await this.httpClient.insertRowAfter(request)
  }

  async insertRowBefore(request: InsertRowAfterRequest) {
    await this.httpClient.insertRowBefore(request)
  }

  async deleteBay(request: DeleteBayRequest) {
    await this.httpClient.deleteBay(request)
  }

  async deleteRow(request: DeleteRowRequest) {
    await this.httpClient.deleteRow(request)
  }
}

export const yardBlockService = new YardBlockService()
